
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/casino/fairness",
      function () {
        return require("private-next-pages/casino/fairness/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/casino/fairness"])
      });
    }
  